export const links = [
    {
        name: 'Главная',
        href: '/',
    },
    {
        name: 'Купить косметику Academie с доставкой.',
        href: '/delivery',
    },
    {
        name: 'Карта сайта',
        href: '/index.php?route=information/sitemap/',
    },
    {
        name: 'Акции',
        href: 'akcii',
    },
    {
        name: 'Личный кабинет',
        href: '/my-account',
    },
    {
        name: 'Горячая линия 8 (800) 555-345-1',
        href: 'tel:88005553451',
    },
    {
        name: 'Условия возврата',
        href: '/vozvrat',
    },
]

export const links_below = [
    {
        name: 'Пользовательское соглашение',
        href: '/polzovatelskoe-soglashenie',
    },
    {
        name: 'Публичная оферта',
        href: '/publichnaja-oferta',
    },
]

// export const links2 = [
//     {
//         name: 'Политика обработки персональных данных',
//         href: '/politika-obrabotki-personalnyx-dannyx',
//     },
//     {
//         name: 'Политика использования cookie',
//         href: '/politika-ispolzovanija-cookie',
//     }
// ]